import { Component } from 'react'
import { ErrorMessage, emptyField, errorsLength, formatErrors } from '../../../../../../insfrastructure/utils/form-validators'
import { Course, CoursePost, createCourse, deleteCourse, listCourses, updateCourse } from '../../../../../../insfrastructure/services/courses'
import { StaticValues } from '../../../../../../insfrastructure/services/static_values'
import { formatUnitName } from '../../../../../../insfrastructure/utils/unit-formatter'
import { formatDateOnly } from '../../../../../../insfrastructure/utils/date-formatter'
import { Input } from '../../../../../components/input'
import { Select } from '../../../../../components/select'
import { SubmitBtn } from '../../../../../components/submit'
import ConfirmationModal from '../../../../../components/confimation-modal'
import CheckboxInput from '../../../../../components/checkbox'
import ResponseModal from '../../../../../components/response-modal'
import './styles.sass'

export default class Scholarships extends Component {

  state: any = {
    scholarship_items: [],
    em_units: []
  }

  getApiErrorMessage = (error: any): string | null => {
    const data = error?.response?.data;
    if (!data) {
      return null;
    }
    if (typeof data === 'string') {
      return data;
    }
    if (Array.isArray(data)) {
      return data.find(Boolean) ?? null;
    }
    if (typeof data === 'object') {
      if (typeof data.detail === 'string') {
        return data.detail;
      }
      if (Array.isArray(data.detail) && data.detail.length > 0) {
        return data.detail[0];
      }
      const firstKey = Object.keys(data).find(key => data[key]);
      if (firstKey) {
        const value = data[firstKey];
        if (Array.isArray(value) && value.length > 0) {
          return value[0];
        }
        if (typeof value === 'string') {
          return value;
        }
      }
    }
    return null;
  }

  async componentDidMount() {
    this.getStaticValues();
    this.listCourses();
  }

  listCourses = async () => {
    try {
      const courses = await listCourses(localStorage.getItem('candidate_id'));

      const scholarship_items = courses.results.map(item => {    
        return {
          item: {
            ...item,
            is_studant: !!item.em_unit
          },
          editing: false
        };
      });

      this.setState({ scholarship_items });
    } catch (error) {}
  }

  getStaticValues = async () => {
    try {  
      const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;
  
      const em_units = Object.values(staticValues.em_unit)
        .map((x: any) => {
          const { formatted, nameOnly } = formatUnitName(x.name);
          return { value: x.id, label: formatted, nameOnly };
        })
        .sort((a, b) => a.nameOnly.localeCompare(b.nameOnly, 'pt-BR', { sensitivity: 'base' }))
        .map(({ value, label }) => ({ value, label }));
      const em_course = Object.keys(staticValues.em_course).map((key: any) => ({ value: parseInt(key), label: staticValues.em_course[key] }));
      const course_progress = Object.keys(staticValues.course_progress).map((key: any) => ({ value: key, label: staticValues.course_progress[key] }));
  
      this.setState({ em_units, em_course, course_progress });
    } catch (error) {}
  }

  editScholarship = (id: number) => {
    const items = [...this.state.scholarship_items].map(x => {
      if(x.item.id === id) {
        x.editing = true;
      };
    
      return x;
    });

    this.setState({ scholarship_items: items });
  }

  addScholarship = () => {
    const items = [...this.state.scholarship_items];
    items.push({
      item: {
        id: 0,
        is_studant: false
      },
      editing: true
    });

    this.setState({ scholarship_items: items });
  }

  onSubmitScholarship = async (x: CoursePost, index: number) => {
    try {
      const currentCourse = this.state.scholarship_items.filter((y: { item: Course }) => 
      x.em_unit && x.em_course ?
      (x.em_unit === y.item.em_unit && x.em_course === y.item.em_course) :
      (x.institution === y.item.institution && x.course_name === y.item.course_name));

      if (currentCourse.length > 0 && currentCourse[0].id && currentCourse[0].id !== x.id) {
        let responseData = {
          type: 'error',
          title: 'Curso já cadastrado',
          text: () => <></>
        };

        const items = [...this.state.scholarship_items].map((y, i) => {
          if(i === index) {
            y.item = x;
            y.editing = true;
          };

          return y;
        });
            
        this.setState({ loading: false, scholarship_items: items, responseData });

        return
      };

      if (x.start_date) {
        const formatted = formatDateOnly(x.start_date);
        if (formatted) x.start_date = formatted;
      }
      if (x.end_date) {
        const formatted = formatDateOnly(x.end_date);
        if (formatted) x.end_date = formatted;
      }

      const newItem = x.id === 0 ? await createCourse(x) : await updateCourse(x.id, x);
  
      const items = [...this.state.scholarship_items].map((y, i) => {
        if(i === index) {
          y.item = {
            ...newItem,
            is_studant: !!newItem.em_unit
          };
          y.editing = false;
        };
      
        return y;
      });

      let responseData = {
        type: 'success',
        title: 'Dados salvos com sucesso!',
        text: () => <></>
      };

      setTimeout(() => {
        this.setState({ loading: false, scholarship_items: items, responseData });
      });
    } catch (error) {
      const apiMessage = this.getApiErrorMessage(error);
      let responseData = {
        type: 'error',
        title: 'Ocorreu um erro',
        text: apiMessage
      };

      this.setState({ loading: false, responseData });
    }
  }

  removeScholarship = async (id: number) => {
    try {
      await deleteCourse(id);

      const items = this.state.scholarship_items.filter((x: any) => x.item.id !== id);

      let responseData = {
        type: 'success',
        title: 'Formação removida com sucesso!',
        text: () => <></>
      };

      setTimeout(() => {
        this.setState({ loading: false, scholarship_items: items, responseData });
      });
    } catch (error) {
      let responseData = {
        type: 'error',
        title: 'Ocorreu um erro inesperado',
        text: () => <></>
      };

      this.setState({ loading: false, responseData });
    }
  }

  render() {
    return (
      <div className='scholarship-form'>
        <h1>Formação</h1>
        <div className='scholarships'>
          {
            this.state.scholarship_items.length > 0 ?
            this.state.scholarship_items.map((x: any, i: number) =>
            <ScholarshipForm
            key={x.item?.id ? `scholarship_${x.item.id}` : `scholarship_new_${i}`}
            formData={x.item}
            readonly={!x.editing}
            em_units={this.state.em_units}
            em_course={this.state.em_course}
            course_progress={this.state.course_progress}
            onSubmit={(e) => this.onSubmitScholarship(e, i)}
            onUpdate={(e) => this.editScholarship(e)}
            onRemove={i => this.removeScholarship(i)} />) :
            <div className='empty-list'>
              <p>Nenhuma formação adicionada</p>
            </div>
          }
        </div>
        {this.state.scholarship_items.filter((item: any) => item.editing).length === 0 &&
        <SubmitBtn className='secondary' text='Adicionar Formação' onSubmit={this.addScholarship} />}
        <ResponseModal
        render={this.state.responseData}
        type={this.state.responseData?.type}
        title={this.state.responseData?.title}
        text={this.state.responseData?.text}
        onClose={() => this.setState({ responseData: null })} />
      </div>
    )
  }
}

class ScholarshipForm extends Component<{formData: Course, em_units: any[], em_course: any[], course_progress: any[], onSubmit: (x: any) => any, onUpdate: (x: any) => any, onRemove: (i: number) => void, readonly: boolean}> {
  state: any = {
    form: {
      is_studant: false
    },
    formErrors: {},
    loading: false
  }

  componentDidMount() {
    if(this.props.formData) {
      this.setState({ form: this.props.formData });
    };
  }

  componentDidUpdate(prevProps: Readonly<{ formData: Course; em_units: any[]; em_course: any[]; onSubmit: (x: any) => any; onUpdate: (x: any) => any; onRemove: (i: number) => void; readonly: boolean }>, prevState: Readonly<{}>, snapshot?: any): void {
    if(prevProps.formData && this.props.formData.id !== prevProps.formData.id) {
      this.setState({ form: this.props.formData });
    };
  }

  onSubmit = async () => {
    let errorsValidators: Record<string, string[]> = {
      description: [emptyField(this.state.form.description, 'string')],
      status: [emptyField(this.state.form.status, 'string')],
      start_date: [emptyField(this.state.form.start_date, 'string')]
    };

    if (this.state.form.is_studant) {
      errorsValidators.em_unit = [emptyField(this.state.form.em_unit, 'string')];
      errorsValidators.em_course = [emptyField(this.state.form.em_course, 'string')];
    } else {
      errorsValidators.institution = [emptyField(this.state.form.institution, 'string')];
      errorsValidators.course_name = [emptyField(this.state.form.course_name, 'string')];
    };

    const errors = formatErrors(errorsValidators);

    this.setState({ formErrors: errors });
  
    if(errorsLength(errors) > 0) return;

    this.setState({ loading: true });

    try {
        this.props.onSubmit(this.state.form);
        
        setTimeout(() => {
            this.setState({ loading: false });
        });
    } catch (error) {
        this.setState({ loading: false });
    }
  }

  onRemoveInterest = () => {
    // if (this.state.form.id === 0) {
    //   this.props.onRemove(this.state.form.id as number);
      
    //   return;
    // };

    this.setState({ selectedItemToDelete: true });
  }

  onRemoveScholarship = async () => {
    this.setState({ loading: true });
    this.setState({ selectedItemToDelete: null });

    try {
        setTimeout(() => {
          this.setState({ loading: false });
          this.props.onRemove(this.state.form.id as number);
        });
    } catch (error) {
        this.setState({ loading: false });
    }
  }

  render() {
    return (
      <div className='form'>
        <div className='columns-group'>
          <div className='columns'>
            <div className='column'>
              <CheckboxInput
              name='is_studant'
              checked={this.state.form['is_studant']}
              disabled={this.props.readonly}
              label='Escola do Mecânico'
              onChange={e => this.setState({ form: 
                { 
                  ...this.state.form,
                  is_studant: e,
                  institution: null,
                  course_name: null,
                  em_unit: null,
                  em_course: null
                }
              })}/>
              <ErrorMessage errors={this.state.formErrors['is_studant']} />
              {!this.state.form.is_studant ?
              <>
                <Input
                name='institution'
                label='Instituição de Ensino'
                placeholder='Instituição de Ensino'
                value={this.state.form['institution']}
                readonly={this.props.readonly}
                onChange={e => this.setState({ form: { ...this.state.form, institution: e } })}/>
                <ErrorMessage errors={this.state.formErrors['institution']} />
                <Input
                name='course_name'
                label='Nome do Curso'
                placeholder='Nome do Curso'
                value={this.state.form['course_name']}
                readonly={this.props.readonly}
                onChange={e => this.setState({ form: { ...this.state.form, course_name: e } })}/>
                <ErrorMessage errors={this.state.formErrors['course_name']} />
              </>:
              <>
                <Select
                name='em_unit'
                label='Unidade da Escola do Mecânico'
                placeholder='Unidade da Escola do Mecânico'
                value={this.state.form['em_unit']}
                readonly={this.props.readonly}
                options={this.props.em_units}
                onChange={e => this.setState({ form: { ...this.state.form, em_unit: e } })}/>
                <ErrorMessage errors={this.state.formErrors['em_unit']} />
                <Select
                name='em_course'
                label='Nome do Curso'
                placeholder='Nome do Curso'
                value={this.state.form['em_course']}
                readonly={this.props.readonly}
                options={this.props.em_course}
                onChange={e => this.setState({ form: { ...this.state.form, em_course: e } })}/>
                <ErrorMessage errors={this.state.formErrors['em_course']} />
              </>}
              <Select
              name='status'
              label='Progresso'
              placeholder='Progresso'
              value={this.state.form['status']}
              readonly={this.props.readonly}
              options={this.props.course_progress}
              onChange={e => this.setState({ form: { ...this.state.form, status: e } })}/>
              <ErrorMessage errors={this.state.formErrors['status']} />
            </div>
            <div className='column'>
              <Input
              name='start_date'
              label='Data de Início'
              placeholder='Data de Início'
              type='date'
              dateFormat='MM/yyyy'
              value={this.state.form['start_date']}
              readonly={this.props.readonly}
              onChange={e => this.setState({ form: { ...this.state.form, start_date: e } })}/>
              <ErrorMessage errors={this.state.formErrors['start_date']} />
              <Input
              name='end_date'
              label='Data de Conclusão'
              placeholder='Data de Conclusão'
              type='date'
              dateFormat='MM/yyyy'
              value={this.state.form['end_date']}
              readonly={this.props.readonly}
              onChange={e => this.setState({ form: { ...this.state.form, end_date: e } })}/>
              <ErrorMessage errors={this.state.formErrors['end_date']} />
            </div>
          </div>
          <div className='full-width-column'>
            <Input
            name='name'
            type='textarea'
            label='Descrição do Curso'
            value={this.state.form['description']}
            placeholder='Descrição do Curso'
            readonly={this.props.readonly}
            onChange={e => this.setState({ form: { ...this.state.form, description: e } })}/>
            <ErrorMessage errors={this.state.formErrors['description']} />
          </div>
        </div>
        <div className='btns'>
          {!this.props.readonly &&
          <SubmitBtn className='secondary' text='Salvar Alterações' loadingText='Salvando...' loading={this.state.loading} onSubmit={this.onSubmit} />}
          {this.props.readonly &&
          <SubmitBtn className='secondary' text='Editar' onSubmit={() => this.props.onUpdate(this.state.form['id'])} />}
          {this.props.readonly &&
          <SubmitBtn className='secondary' text='Remover' loadingText='Removendo...' loading={this.state.loading} onSubmit={this.onRemoveInterest} />}
        </div>
        <ConfirmationModal
        title='Deletar esse cargo de interesse?'
        text='Tem certeza que deseja deletar esse cargo de interesse? Nós não mostraremos ele novamente para você.'
        render={this.state.selectedItemToDelete}
        onConfirm={this.onRemoveScholarship}
        onClose={() => this.setState({ selectedItemToDelete: null })}/>
      </div>
    )
  }
}

